jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchstart", handle, { passive: false });
    } else {
      this.addEventListener("touchstart", handle, { passive: true });
    }
  },
};

jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchmove", handle, { passive: false });
    } else {
      this.addEventListener("touchmove", handle, { passive: true });
    }
  },
};

$(".btn-darkred, .btn-blue, .btn-red, .btn-orange, .btn-black, .cta-btn").each(
  function () {
    var originalText = $(this)
      .contents()
      .filter(function () {
        return this.nodeType === 3;
      })
      .text()
      .trim();

    if (originalText) {
      $(this).html(
        '<div class="slide-in-bottom"><span data-hover="' +
          originalText +
          '">' +
          originalText +
          "</span></div>"
      );
    }
  }
);

function wrapTextWithAnimation(selector, iconClass) {
  $(selector).each(function () {
    var originalText = $(this)
      .contents()
      .filter(function () {
        return this.nodeType === 3;
      })
      .text()
      .trim();

    if (originalText) {
      $(this).html(
        '<div class="slide-in-bottom"><span data-hover="' +
          originalText +
          '">' +
          originalText +
          '<div class="' +
          iconClass +
          '"></div>' +
          "</span></div>"
      );
    }
  });
}

wrapTextWithAnimation(".link-wrapper.btn-white", "icon-link");

//AOS.init()

/**** Main menu ****/
var body = $("body");
var naviOpen = $("li.menu a");
var naviContainer = $("li.menu ul.level2");
var naviClose = $("#close-navi");

naviContainer.removeClass("active");
naviOpen.on("click", function () {
  naviContainer.addClass("active");
  body.addClass("navi-open");
});

naviClose.on("click", function () {
  naviContainer.removeClass("active");
  body.removeClass("navi-open");
});

if ($(".gallery-slider").length > 0) {
  document.addEventListener("DOMContentLoaded", function () {
    var splide = new Splide(".gallery-slider", {
      rewind: true,
      arrows: true,
      pagination: true,
      perPage: 1,
      drag: true,
      speed: 1500,
      rewind: true,
      rewindSpeed: 1500,
    }).mount();
  });
}

if ($(".logo-splide").length > 0) {
  document.addEventListener("DOMContentLoaded", function () {
    var $splide = $(".logo-splide");
    var slideCount = $splide.find(".splide__slide").length;
    var isMobile = window.innerWidth < 768;

    // Init if mobile OR more than 3 items
    if (isMobile || slideCount > 2) {
      new Splide(".logo-splide", {
        type: "loop",
        drag: "free",
        focus: "center",
        gap: "96px",
        autoWidth: true,
        pagination: false,
        arrows: false,
        autoScroll: {
          speed: -0.5
        }
      }).mount(window.splide.Extensions);
    } else {
      $splide.addClass("is-static");
    }
  });
}


// AJAX CONTENT LOADER
var loader = {
  init: function (
    triggerSelector,
    targetSelector,
    callbackBefore,
    callbackAfter
  ) {
    $("body").on("click", triggerSelector, function () {
      window.history.pushState(null, null, $(this).attr("href"));

      if (callbackBefore !== undefined) {
        callbackBefore($(this));
      }

      loader.load($(this).attr("href"), targetSelector, callbackAfter);

      return false;
    });
  },
  load: function (url, targetSelector, callbackAfter) {
    $(".list-loader").show();

    url += url.includes("?") ? "&ajax" : "?ajax";

    $.get(url).then(function (response) {
      $(targetSelector).html(response);
    });
  },
};

//PRODUCTS LIST
loader.init(".products-list-dynamic .pagination a", ".products-list-dynamic");
loader.init(".product-list-link", ".products-list-dynamic", function (trigger) {
  if (trigger.hasClass("product-list-link")) {
    $(".products-filters .active").removeClass("active");
    trigger.parent().addClass("active");
  }
});
